import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AlertCard from "./AlertCard.vue";

/**
 * An alert for components that are still under construction.
 */
const __default__ = {
  name: "UnderConstructionAlert",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AlertCard, {
    type: "warning",
    message: "This content is still under construction. Check back soon!",
    class: "q-my-md"
  }))
}
}

})